/** @format */

import { FilterCategoryOptions } from "@/app/(main)/danh-muc/[slug]/DanhmucClient";
import api from "../interceptor";
import { apiCache, CACHE_DURATION } from "@/lib/cache";
import { AxiosResponse } from "axios";
const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

const url = `/categories`;

export const CategoryAPI = {
  // productFilterSlug
  getCategoryWithSlug: async ({
    slug,
    currentPage = 1,
    limit = 4,
    productFilterSlug,
    filterOptions,
  }: {
    slug: string;
    currentPage: number;
    limit: number;
    productFilterSlug?: string;
    filterOptions?: FilterCategoryOptions;
  }) => {
    return await api({
      method: "GET",
      url: `${url}/${slug}`,
      params: {
        storeID,
        currentPage,
        limit,
        productFilterSlug,
        ...(filterOptions && {
          maxPrice: filterOptions?.maxPrice,
          minPrice: filterOptions?.minPrice,
        }),
      },
    });
  },

  getAllCategoriesOfStore: async ({
    justGetParent,
    currentPage,
    limit,
  }: {
    justGetParent: boolean;
    currentPage?: number;
    limit?: number;
  }) => {
    // return await api({
    //   method: "GET",
    //   url: url,
    //   params: {
    //     justGetParent,
    //     storeID,
    //     limit,
    //     currentPage,
    //   },
    // });
    const cacheKey = `categories_${storeID}_${justGetParent}_${currentPage ?? "all"}_${limit ?? "all"}`;

    return await apiCache.getOrFetch<AxiosResponse>(
      cacheKey,
      CACHE_DURATION.FIVE_MINUTES,
      async () => {
        return await api({
          method: "GET",
          url: url,
          params: {
            justGetParent,
            storeID,
            limit,
            currentPage,
          },
        });
      },
    );
  },
};
